<template>
  <div id="admin-push-notifications">
    <info-box v-bind:description="description"></info-box>
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>

    <div class="notification-container">
      <div v-if="notification" class="notification" :class="notificationType">
        {{notification}}
      </div>

      <div class="form-container">
        <h2>Send Push Notification</h2>

        <div class="form-group">
          <label>Notification Title:</label>
          <input
            type="text"
            v-model="notificationTitle"
            placeholder="Enter notification title"
            class="input-field"
          />
        </div>

        <div class="form-group">
          <label>Notification Message:</label>
          <textarea
            v-model="notificationMessage"
            placeholder="Enter notification message"
            class="textarea-field"
            rows="4"
          ></textarea>
        </div>

        <div class="form-group">
          <label>Target Audience:</label>
          <select v-model="targetType" class="select-field">
            <option value="topic">Send to Topic</option>
            <!-- <option value="user">Send to Specific User</option>
            <option value="endpoint">Send to Specific Endpoint</option> -->
          </select>
        </div>

        <div v-if="targetType === 'topic'">
          <div class="form-group">
            <label>Category (when/why):</label>
            <select v-model="selectedCategory" class="select-field">
              <option value="live">Live - User went live streaming</option>
              <option value="update">Update - General announcements</option>
            </select>
          </div>

          <div class="form-group">
            <label>Type (what content):</label>
            <select v-model="selectedType" class="select-field">
              <option value="all">All - All game types</option>
              <option value="minigames">Minigames</option>
              <option value="party">Party</option>
              <option value="playtogether">Play Together</option>
              <option value="solosquad">Solo Squad</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>

        <div class="form-group" v-if="targetType === 'user'">
          <label>User ID:</label>
          <input
            type="text"
            v-model="targetUserId"
            placeholder="Enter user ID"
            class="input-field"
          />
        </div>

        <div class="form-group" v-if="targetType === 'endpoint'">
          <label>Endpoint ARN:</label>
          <input
            type="text"
            v-model="targetEndpoint"
            placeholder="Enter SNS endpoint ARN"
            class="input-field"
          />
        </div>

        <div class="form-group">
          <label>Platform:</label>
          <div class="checkbox-group">
            <label>
              <input type="checkbox" v-model="platforms.ios" /> iOS
            </label>
            <label>
              <input type="checkbox" v-model="platforms.android" /> Android
            </label>
          </div>
        </div>

        <div class="form-group">
          <label>Additional Data (JSON):</label>
          <textarea
            v-model="additionalData"
            placeholder='{"key": "value"}'
            class="textarea-field"
            rows="3"
          ></textarea>
        </div>

        <div class="button-group">
          <button
            class="btn-enabled"
            @click="sendNotification"
            :disabled="sending || !isFormValid"
          >
            {{sending ? 'Sending...' : 'Send Notification'}}
          </button>
          <button
            class="btn-secondary"
            @click="resetForm"
          >
            Reset Form
          </button>
        </div>

        <div class="stats-container" v-if="lastSendResult">
          <h3>Last Send Result:</h3>
          <div class="stats-content">
            <div v-if="lastSendResult.success">
              <p><strong>Status:</strong> <span class="success-text">Success</span></p>
              <p v-if="lastSendResult.messageId"><strong>Message ID:</strong> {{lastSendResult.messageId}}</p>
              <p v-if="lastSendResult.recipientCount"><strong>Recipients:</strong> {{lastSendResult.recipientCount}}</p>
            </div>
            <div v-else>
              <p><strong>Status:</strong> <span class="error-text">Failed</span></p>
              <p v-if="lastSendResult.error"><strong>Error:</strong> {{lastSendResult.error}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'admin-push-notifications',
  components: {
  },
  async mounted () {
  },
  data () {
    return {
      title_img: 'swiftorland-title.svg',
      description: {
        title: 'Admin Push Notifications',
        text: 'Send push notifications to users'
      },
      notification: undefined,
      notificationType: 'info',
      notificationTitle: '',
      notificationMessage: '',
      targetType: 'topic',
      selectedCategory: 'live',
      selectedType: 'all',
      targetUserId: '',
      targetEndpoint: '',
      platforms: {
        ios: true,
        android: true,
        web: false
      },
      additionalData: '',
      sending: false,
      lastSendResult: null
    }
  },
  computed: Object.assign(mapState(['currentUser']), {
    isFormValid () {
      if (!this.notificationTitle || !this.notificationMessage) {
        return false
      }

      if (this.targetType === 'topic' && (!this.selectedCategory || !this.selectedType)) {
        return false
      }

      if (this.targetType === 'user' && !this.targetUserId) {
        return false
      }

      if (this.targetType === 'endpoint' && !this.targetEndpoint) {
        return false
      }

      if (!this.platforms.ios && !this.platforms.android && !this.platforms.web) {
        return false
      }

      return true
    }
  }),
  methods: {
    async sendNotification () {
      this.sending = true
      this.lastSendResult = null

      try {
        // Validate JSON if provided
        let parsedData = null
        if (this.additionalData.trim()) {
          try {
            parsedData = JSON.parse(this.additionalData)
          } catch (e) {
            this.notify('Invalid JSON in additional data field', 'error')
            this.sending = false
            return
          }
        }

        const payload = {
          title: this.notificationTitle,
          message: this.notificationMessage,
          targetType: this.targetType,
          platforms: this.platforms
        }

        if (this.targetType === 'topic') {
          payload.category = this.selectedCategory
          payload.type = this.selectedType
        } else if (this.targetType === 'user') {
          payload.userId = this.targetUserId
        } else if (this.targetType === 'endpoint') {
          payload.endpointArn = this.targetEndpoint
        }

        if (parsedData) {
          payload.data = parsedData
        }

        const response = await axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/admin/push-notification`, payload, {withCredentials: true})

        this.lastSendResult = {
          success: true,
          messageId: response.data.messageId,
          recipientCount: response.data.recipientCount
        }

        this.notify('Push notification sent successfully!', 'success')
      } catch (error) {
        console.error('Error sending notification:', error)

        const errorMessage = (error.response && error.response.data && error.response.data.error && error.response.data.error.message) || error.message

        this.lastSendResult = {
          success: false,
          error: errorMessage
        }

        this.notify(
          errorMessage || 'Failed to send notification. Check console for details.',
          'error'
        )
      } finally {
        this.sending = false
      }
    },
    resetForm () {
      this.notificationTitle = ''
      this.notificationMessage = ''
      this.targetType = 'topic'
      this.selectedCategory = 'live'
      this.selectedType = 'all'
      this.targetUserId = ''
      this.targetEndpoint = ''
      this.platforms = {
        ios: true,
        android: true,
        web: false
      }
      this.additionalData = ''
      this.lastSendResult = null
    },
    notify (text, type = 'info') {
      this.notification = text
      this.notificationType = type
      setTimeout(() => {
        this.notification = undefined
      }, 5000)
    }
  }
}
</script>

<style scoped>
.notification-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.notification {
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
}

.notification.info {
  background-color: #5A3E85;
  color: white;
}

.notification.success {
  background-color: #4CAF50;
  color: white;
}

.notification.error {
  background-color: #b62626;
  color: white;
}

.form-container {
  background-color: #2a2a2a;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);
}

.form-container h2 {
  color: white;
  margin-bottom: 20px;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: white;
  margin-bottom: 8px;
  font-weight: bold;
}

.input-field,
.textarea-field,
.select-field {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 2px solid #5A3E85;
  background-color: #1a1a1a;
  color: white;
  font-size: 14px;
  box-sizing: border-box;
}

.input-field:focus,
.textarea-field:focus,
.select-field:focus {
  outline: none;
  border-color: #7e55bb;
}

.textarea-field {
  resize: vertical;
  font-family: inherit;
}

.checkbox-group {
  display: flex;
  gap: 20px;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: normal;
  margin-bottom: 0;
}

.checkbox-group input[type="checkbox"] {
  width: auto;
  cursor: pointer;
}

.button-group {
  display: flex;
  gap: 10px;
  margin-top: 30px;
}

.btn-enabled {
  flex: 1;
  background-color: #5A3E85;
  color: white;
  border: none;
  border-top: 2px rgb(126, 85, 187) solid;
  padding: 12px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s;
  box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
}

.btn-enabled:hover:not(:disabled) {
  background-color: #7e55bb;
}

.btn-enabled:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-secondary {
  flex: 1;
  background-color: #3a3a3a;
  color: white;
  border: none;
  border-top: 2px #5a5a5a solid;
  padding: 12px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s;
  box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
}

.btn-secondary:hover {
  background-color: #4a4a4a;
}

.stats-container {
  margin-top: 30px;
  padding: 20px;
  background-color: #1a1a1a;
  border-radius: 5px;
  border: 1px solid #5A3E85;
}

.stats-container h3 {
  color: white;
  margin-bottom: 15px;
}

.stats-content p {
  color: white;
  margin: 8px 0;
}

.success-text {
  color: #4CAF50;
  font-weight: bold;
}

.error-text {
  color: #ff5555;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin-Push-Notifications.vue